module.exports = __webpack_public_path__ + "static/img/Sintegra-2020-72.e5e96f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Sintegra-2020-72.png
// module id = jLLf
// module chunks = 0